import { useSyncExternalStore } from 'react';

type Listener = () => void;

let frozen = false;
const listeners = new Set<Listener>();

function emit(): void {
  for (const listener of listeners) listener();
}

/**
 * "Tổ chức trong phiên đang đóng băng" — APM-ORGMS-f, docs/plan-org-restructure.md §3.7.
 *
 * Lượt gộp / tách đang chạy thì API trả `423 ORG_RESTRUCTURING` cho **mọi** request vào tổ
 * chức ấy (trừ vài đường mở sẵn). Bắt ở `apiFetch` — một chỗ — chứ không ở từng query: bắt
 * theo query thì mỗi màn hình phải nhớ tự xử, và màn hình nào quên hiện `ErrorState` đỏ với
 * câu "thử lại sau" cho một việc chẳng hỏng gì. Vỏ `_app` đọc cờ này và thay nội dung trang
 * bằng màn hình chờ; màn hình chờ tự dò tới khi tổ chức mở lại rồi gỡ cờ.
 *
 * Nằm ngoài React vì `http.ts` ghi nó ở tầng không có hook — cùng lý do với `tokenStore`.
 */
export const orgRestructuringStore = {
  get(): boolean {
    return frozen;
  },

  mark(): void {
    if (frozen) return;
    frozen = true;
    emit();
  },

  clear(): void {
    if (!frozen) return;
    frozen = false;
    emit();
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  /** Chỉ dùng trong test. */
  reset(): void {
    frozen = false;
  },
};

export function useOrgRestructuring(): boolean {
  return useSyncExternalStore(
    orgRestructuringStore.subscribe,
    orgRestructuringStore.get,
    orgRestructuringStore.get,
  );
}
